import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../api';
// 1. The "Library" function (CORRECTED for native fetch)
const fetchNamespaces = async (projectId,section) => {
  return await apiRequest(`/api/namespaces/${projectId}/${section}`, {
    method: 'POST', // Explicitly set POST to match Flask
    body: JSON.stringify({}), // Send an empty object if no data is needed
  });  
};

// 2. The Custom Hook (This part is PERFECT)
export const useNamespaces = (projectId , section="build") => {
  return useQuery({
    queryKey: ['namespaces', projectId,section], 
    queryFn: () => fetchNamespaces(projectId,section),
    enabled: !!projectId && !!section,
    staleTime: 1000 * 60 * 5, 
  });
};
